export default "__VITE_ASSET__Dl6xjc14__"